import React, { useEffect } from "react";
import service1 from "../../assets/img/service_1.png";
import phone_icon from "../../assets/img/phone.png";
import { ReactTyped } from "react-typed";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../App.css";
import { Link } from "react-router-dom";

const HomeCleaning = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="service_detail_page">
      <h2 className="service_detail_title" data-aos="fade-down">
        Residential Cleaning
      </h2>

      <img
        src={service1}
        alt="Residential Cleaning"
        className="service_detail_image"
        data-aos="zoom-in"
      />

      <p className="service_detail_cta" data-aos="fade-up">
        Well maintained. Simply managed.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        Residential cleaning in Auckland for homeowners and landlords who prefer
        structure over uncertainty. Weekly, fortnightly or one off support
        delivered through defined checklists and consistent team allocation.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        From scheduling to invoicing, everything follows a clear system.
        Clients know when we are arriving, what standard is expected and how
        communication flows.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        We use environmentally responsible products wherever suitable. Safe for
        families, pets and everyday living.
      </p>

      <h4 className="service_subheading" data-aos="fade-up">
        Who We Support
      </h4>
      <ul className="service_detail_points" data-aos="fade-up">
        <li>Owner occupied homes</li>
        <li>Rental properties</li>
        <li>Landlords and property managers</li>
      </ul>

      <h4 className="service_subheading" data-aos="fade-up">
        Why Luxe Sparkle
      </h4>
      <ul className="service_detail_points" data-aos="fade-up">
        <li>Consistent team allocation builds familiarity</li>
        <li>Structured quality controls maintain standards</li>
        <li>Clear scheduling and transparent invoicing</li>
        <li>Flexible arrangements that work long term</li>
      </ul>

      <p className="service_detail_cta" data-aos="fade-up">
        Homes stay maintained. Time stays yours.
      </p>

      <div className="service_btn_wrapper" data-aos="fade-up">
        <Link to="/booking" className="service_btn">
          Get a Free Quote
        </Link>
      </div>

      <div className="service_contact_section">
        <div className="about_sub2">
          <div className="about_contact">
            <p className="contact-lead">
              Looking for the cleaning service in Auckland?
              <br />
              Contact us now!
            </p>
            <div className="call_btn" data-aos="fade-down">
              <div className="call_inner">
                <div className="call_icon">
                  <img src={phone_icon} alt="Phone" />
                </div>
                <a className="call-button" href="tel:092430470">
                  09 243 0470
                </a>
              </div>
            </div>
          </div>

          <div className="about_faq">
            <ReactTyped
              strings={["Need help?", "Have questions?", "Check our FAQs!"]}
              typeSpeed={50}
              backSpeed={30}
              loop
            />
            <br />
            <Link className="faq-button" to="/FAQs">
              FAQs
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCleaning;
